module.exports = __webpack_public_path__ + "media/images/vector-12@2x-81cc4d756a0c224c8beff359b6359ceb.png";